import { useHoneyBalance } from "@/hooks/use-honey";

interface HoneyBalanceProps {
  className?: string;
  showLabel?: boolean;
  onClick?: () => void;
}

export function HoneyBalance({ className = "", showLabel = true, onClick }: HoneyBalanceProps) {
  const { data: balance, isLoading } = useHoneyBalance();
  if (isLoading) return null;

  const Tag = onClick ? "button" : "div";

  return (
    <Tag
      type={onClick ? "button" : undefined}
      data-testid="pill-honey-balance"
      onClick={onClick}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-2xl bg-primary/10 border border-primary/30 transition-colors ${onClick ? 'hover:bg-primary/15 cursor-pointer' : ''} ${className}`}
    >
      <span className="text-sm leading-none">🍯</span>
      <span className="font-bold text-xs text-primary tabular-nums">{balance ?? 0}</span>
      {showLabel && <span className="text-[10px] text-zinc-500 ml-0.5">Honey</span>}
    </Tag>
  );
}
